import * as React from 'react';
import * as reviews from "./style.module.scss";
import dataAdult from "./data.json";
import dataYoung from "./dataYoung.json";
export const VideoReviews = ({ data='adult'}) => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={`${reviews.reviews} container`}>
      <h2 className={reviews.reviews__title}>
        Отзывы наших учеников:
      </h2>
      <swiper-wrapper style={{ position: "relative" }}>
        <swiper-container
          ref={swiperEl}
          init="false"
          style={{
            width: "100%",
            overflowX: "hidden",
            paddingBottom: "40px",
          }}
        >
          {
            (data === 'young' ? dataYoung : dataAdult).map((elem, index) => (
              <swiper-slide className={reviews.reviews__item} key={index}>
                <div className={reviews.reviews__item}>
                  <div className={reviews.reviews__video}>
                    <iframe
                      height="315"
                      src={elem.video}
                      title={`${elem.name}, отзыв на пройденный курс`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <div className={reviews.reviews__info}>
                    <p className={reviews.reviews__name}>
                      {elem.name}
                    </p>
                    <p className={reviews.reviews__courseName}>
                      {elem.course}
                    </p>
                    <p className={reviews.reviews__result}>
                      Результаты:
                    </p>
                    <ul>
                      {
                        elem.results.map((elem, index) => (
                          <li className={reviews.reviews__resultItem} key={index}>
                            {elem}
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              </swiper-slide>
            ))
          }
        </swiper-container>
        <div
          className="swiper-pagination"
          style={{
            "--swiper-pagination-bullet-size": "18px",
            "--swiper-pagination-color": '#9633FB'
          }}
        />
        <div className={`swiper-button-prev ${reviews.swiperButtonPrev}`} style={{"--swiper-navigation-color": "#9633FB"}}></div>
        <div className={`swiper-button-next ${reviews.swiperButtonNext}`} style={{"--swiper-navigation-color": "#9633FB"}}></div>
      </swiper-wrapper>
    </section>
  );
};
